export const HALF_PRICE_TITLE_SUFFIX = " — Meia-entrada";
export const HALF_PRICE_QUOTA_RATIO = 0.4;

export type HalfPriceRule = {
  key: string;
  title: string;
  proof: string;
};

export const HALF_PRICE_RULES: HalfPriceRule[] = [
  {
    key: "student",
    title: "Estudantes",
    proof:
      "Carteira de Identificação Estudantil (CIE) com foto, instituição de ensino, validade e certificação digital. Não vale boleto, declaração de matrícula ou carteirinha fora desse padrão.",
  },
  {
    key: "autism_pcd",
    title: "Pessoas com deficiência ou autismo",
    proof:
      "Carteira de PCD, laudo ou CIPTEA (Carteira de Identificação da Pessoa com Transtorno do Espectro Autista). O acompanhante também tem direito quando necessário.",
  },
  {
    key: "elderly",
    title: "Idosos (60 anos ou mais)",
    proof: "RG ou documento oficial com foto e data de nascimento.",
  },
  {
    key: "cadunico",
    title: "Jovens de 15 a 29 anos de baixa renda",
    proof: "Comprovante de inscrição no CadÚnico, com renda familiar de até 2 salários mínimos.",
  },
];

export function halfPriceTitle(title: string): string {
  if (title.includes("Meia-entrada")) return title;
  return `${title}${HALF_PRICE_TITLE_SUFFIX}`;
}

export function defaultHalfPriceAmount(price: number): number {
  return Math.round((Number(price) / 2) * 100) / 100;
}

export function defaultHalfPriceQuantity(quantity: number): number {
  return Math.max(1, Math.ceil(Number(quantity) * HALF_PRICE_QUOTA_RATIO));
}

export function buildHalfPriceTicket<
  T extends { title: string; price: number; quantity: number; id?: number },
>(
  fullTicket: T,
  overrides?: { price?: number; quantity?: number },
): T {
  return {
    ...fullTicket,
    id: undefined,
    title: halfPriceTitle(fullTicket.title),
    price: overrides?.price ?? defaultHalfPriceAmount(fullTicket.price),
    quantity: overrides?.quantity ?? defaultHalfPriceQuantity(fullTicket.quantity),
    half_price: true,
    parent_ticket_id: fullTicket.id,
  } as T;
}
